module.exports = __webpack_public_path__ + "static/media/app-profile-detail.05f8133e.jpeg";